import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

import CenteredWrapper from 'ui/CenteredWrapper';
import Heading from 'ui/Heading';
import { FlexItem, HR } from 'components/forms/Forms.styles';
import EssayPromptForm from './EssayPromptForm';
import AccessDenied from 'components/AccessDenied';

const CreateEssayPromptPage = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initPrompt = {
    promptTitle: '',
    level: '',
    essayType: '',
    minWordCount: '',
    shortPrompt: '',
    prompt: '',
    types: [''],
    tags: [''],
  };

  const createPrompt = async (values, status) => {
    setIsSubmitting(true);
    api
      .post(`${API_BASE}/api/essay-prompt/create`, { ...values, status })
      .then((res) => {
        if (res.status == 200) {
          const promptId = res.data?.data;
          navigate(`/essay-prompt/${promptId}`);
        }
      })
      .catch(() => alert('Failed to create a new essay prompt.'))
      .finally(() => setIsSubmitting(false));
  };

  if (!isAuthenticated || !isAdmin) {
    return <AccessDenied />;
  }

  return (
    <CenteredWrapper
      display="flex"
      justifyContent="start"
      flexDirection="column"
      mt="80px"
      minHeight="calc(100vh - 180px)"
      maxWidth="900px"
    >
      <FlexItem>
        <Heading variant="h2">New Essay Prompt</Heading>
      </FlexItem>
      <HR className="light" />
      <EssayPromptForm
        data={initPrompt}
        updatePrompt={createPrompt}
        isDisabled={isSubmitting}
        isEdit={false}
      />
    </CenteredWrapper>
  );
};

export default CreateEssayPromptPage;
